<template>
  <ion-content fullscreen>
    <ion-grid>
      <ion-row>
        <ion-col>
          <h2 class="logo">Log in op tonytalks</h2>
        </ion-col>
      </ion-row>

      <form @submit.prevent="processForm">
        <ion-row class="ion-padding-top">
          <ion-col
            size="10"
            offset="1"
            size-sm="10"
            offset-sm="1"
            size-md="8"
            offset-md="2"
            size-lg="6"
            offset-lg="3"
            size-xl="4"
            offset-xl="4"
          >
            <ion-list lines="full" class="ion-no-margin ion-no-padding">
              <ion-item>
                <ion-label position="floating"
                  >E-mailadres
                  <ion-text color="danger">*</ion-text>
                </ion-label>
                <ion-input required type="email" @input="email = $event.target.value"></ion-input>
              </ion-item>

              <ion-item>
                <ion-label position="floating"
                  >Wachtwoord
                  <ion-text color="danger">*</ion-text>
                </ion-label>
                <ion-input
                  required
                  type="password"
                  @input="password = $event.target.value"
                ></ion-input>
              </ion-item>
            </ion-list>
          </ion-col>
        </ion-row>

        <ion-row class="ion-padding-bottom">
          <ion-col
            size="10"
            offset="1"
            size-sm="10"
            offset-sm="1"
            size-md="8"
            offset-md="2"
            size-lg="6"
            offset-lg="3"
            size-xl="4"
            offset-xl="4"
          >
            <ion-anchor href="/reset-password" router-direction="forward" class="forgot">
              Wachtwoord vergeten?
            </ion-anchor>
          </ion-col>
        </ion-row>

        <ion-row class="ion-padding-top">
          <ion-col
            size="10"
            offset="1"
            size-sm="10"
            offset-sm="1"
            size-md="8"
            offset-md="2"
            size-lg="6"
            offset-lg="3"
            size-xl="4"
            offset-xl="4"
          >
            <ion-button expand="block" color="primary" type="submit" class="ion-no-margin"
              >Aanmelden</ion-button
            >
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col
            size="10"
            offset="1"
            size-sm="10"
            offset-sm="1"
            size-md="8"
            offset-md="2"
            size-lg="6"
            offset-lg="3"
            size-xl="4"
            offset-xl="4"
          >
            <ion-button expand="block" color="light" class="ion-no-margin" href="/register"
              >Maak een account</ion-button
            >
          </ion-col>
        </ion-row>
      </form>
    </ion-grid>
  </ion-content>
</template>
<style lang="scss" scoped>
ion-item {
  --padding-start: 0;
}
.logo {
  font-family: "Eina", sans-serif;
  color: rgb(15, 22, 32);
  text-align: center;
  margin-top: 10vh;
  font-size: 24px;
  font-weight: 500;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
}

.forgot {
  font-size: 14px;
  font-weight: 500;
}
</style>
<script>
import * as firebase from "firebase/app";

export default {
  name: "login",
  components: {},
  data() {
    return {
      email: "",
      password: "",
      errorMsg: ""
    };
  },
  methods: {
    presentAlert(error) {
      if (error.code === "auth/user-not-found") {
        this.errorMsg = "Er is geen gebruiker gevonden dat overeenkomt met de ingevulde gegevens.";
      }

      if (error.code === "auth/wrong-password") {
        this.errorMsg = "Het wachtwoord is ongeldig of de gebruiker heeft geen wachtwoord.";
      }
      return this.$ionic.alertController
        .create({
          header: "Error",
          message: this.errorMsg,
          buttons: ["OK"]
        })
        .then(a => a.present());
    },
    processForm() {
      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then(
          user => {
            this.$router.replace("dashboard");
          },
          err => {
            this.presentAlert(err);
            console.log(err);
          }
        );
    }
  }
};
</script>
